import request from '@/http/request'
import {
  queryRole,
  getRoleTypeMenu,
  getEditUserData,
  queryRoleUserSet,
  deleteUser,
  submitRole,
  deleteRole,
  setUserRole,
  addRoleMenu,
  getSystemUserList,
  getTypeRoleList,
  addSystemUser,
  editUser,
  stationUserImport,
  itinerantTeacherImport
} from '@/http/api'

// stationUserImport

// 获取权限类型对应的角色列表(文件)
export const stationUserImportSet = (data) => {
  return request({
    url: stationUserImport,
    data,
    isUpload:true
  })
}

// 获取权限类型对应的角色列表
export const editUserSet = (data) => {
  return request({
    url: editUser,
    data
  })
}

// 获取权限类型对应的角色列表
export const addSystemUserSet = (data) => {
  return request({
    url: addSystemUser,
    data
  })
}

// 获取权限类型对应的角色列表
export const getTypeRoleListInfo = (data) => {
  return request({
    url: getTypeRoleList,
    data
  })
}

// 设置用户角色(设置,取消)
export const getSystemUserListInfo = (data) => {
  return request({
    url: getSystemUserList,
    data
  })
}

// 设置用户角色(设置,取消)
export const addRoleMenuSet = (data) => {
  return request({
    url: addRoleMenu,
    data
  })
}

// 设置用户角色(设置,取消)
export const isSetUserRole = (data) => {
  return request({
    url: setUserRole,
    data
  })
}

// 删除角色
export const deleteRoleSet = (data) => {
  return request({
    url: deleteRole,
    data
  })
}
// 添加/编辑 用户数据
export const submitRoleSet = (data) => {
  return request({
    url: submitRole,
    data
  })
}
// 删除用户数据
export const deleteUserSet = (data) => {
  return request({
    url: deleteUser,
    data
  })
}
//角色管理列表
export const queryRoleList = (data) => {
  return request({
    url: queryRole,
    data
  })
}
// 获取角色授权数据
export const getRoleTypeMenuInfo = (data) => {
  return request({
    url: getRoleTypeMenu,
    data
  })
}
// 获取用户编辑数据
export const getEditUserDataList = (data) => {
  return request({
    url: getEditUserData,
    data
  })
}
// 角色用户设置列表
export const queryRoleUserSetList = (data) => {
  return request({
    url: queryRoleUserSet,
    data
  })
}
export const itinerantTeacherImports = (data) => {
  return request({
    url: itinerantTeacherImport,
    data,
    isUpload:true
  })
}